import React, { useState, useRef } from "react";
import { CardMedia, Button, Stack, CircularProgress } from "@mui/material";
import axios from "../../api/axios"; // Make sure this is configured correctly
import SnackbarAlert from "../SnackbarAlert";

const DEFAULT_IMAGE = "/assets/placeholders/no-image.jpg";

const CropImage = ({ image, alt, crop_id, onImageChange }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
  const [imgSrc, setImgSrc] = useState(
    image ? `${baseUrl}/${image}` : DEFAULT_IMAGE
  );
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleError = () => {
    setImgSrc(DEFAULT_IMAGE);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const localUrl = URL.createObjectURL(file);
    setImgSrc(localUrl);

    const formData = new FormData();
    formData.append("file", file);

    setUploading(true);
    try {
      const res = await axios.post(
        `/api/v1/crops/${crop_id}/upload-image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (res?.data?.image && onImageChange) {
        onImageChange(res.data.image);
        setImgSrc(`${baseUrl}/${res.data.image}`);
      }

      setSnackbarMsg("Image uploaded successfully");
      setSnackbarType("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Image upload failed", err);
      handleError();
      setSnackbarMsg("Failed to upload image");
      setSnackbarType("error");
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
    }
  };

  const handleButtonClick = () => {
    if (!uploading) fileInputRef.current.click();
  };

  return (
    <Stack spacing={2} alignItems="start">
      <CardMedia
        component="img"
        height="300"
        image={imgSrc}
        alt={alt || "Crop Image"}
        onError={handleError}
        sx={{ objectFit: "cover", borderRadius: 2 }}
      />

      <input
        type="file"
        accept="image/*"
        name="image"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      <Button
        variant="outlined"
        onClick={handleButtonClick}
        size="small"
        sx={{ mr: 1 }}
        disabled={uploading}
        startIcon={uploading ? <CircularProgress size={16} /> : null}
      >
        {image ? "Change Image" : "Add Image"}
      </Button>

      <SnackbarAlert
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={snackbarType}
        message={snackbarMsg}
      />
    </Stack>
  );
};

export default CropImage;
